module.exports = __webpack_public_path__ + "img/logo-pos.9b593f71.svg";